import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.ADVICE}`;

export const AKA_GROUP_LIFE_DEATH_G_VALUE_OPTIONS = [12, 22, 40];
export const AKA_GROUP_LIFE_INCAP_G_VALUE_OPTIONS = [12, 22, 30];
export const AKA_GROUP_LIFE_TIME_G_VALUE_MAX = 2;
export const AKA_CRITICAL_ILLNESS_G_VALUE_MAX = 10;

export const AKA_GROUP_LIFE_DEATH_DEFAULT_G_VALUE = 12;
export const AKA_GROUP_LIFE_INCAP_DEFAULT_G_VALUE = 12;
export const AKA_GROUP_LIFE_TIME_DEFAULT_G_VALUE = 1;
export const AKA_CRITICAL_ILLNESS_DEFAULT_G_VALUE = 1;

export const DOCUMENT_MAX_COMMENT_LINES = 42;
